import { ChangeDetectionStrategy, Component, inject, computed } from '@angular/core';

import { AuthStore } from '@program-suite/data-auth';
import { ProgramTilesComponent } from '@program-suite/ui';
import { getGreeting } from '@program-suite/util-helpers';
import { Router } from '@angular/router';
import { ProgramTile } from '@program-suite/data-common';

@Component({
  selector: 'lib-app-dashboard',
  imports: [ProgramTilesComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent {
  userStore = inject(AuthStore);
  greeting!: string;
  firstName = computed(() => this.userStore.user()?.firstName);

  constructor(private router: Router) {
    this.greeting = getGreeting();
  }

  handleTileSelect(tile: ProgramTile) {
    if (tile.routingUrl) {
      // routingUrl is DB-driven tile JSON and may carry a query string (e.g.
      // 'lio-quote/new?tenantId=5'). navigateByUrl parses the full URL, whereas
      // navigate([routingUrl]) would encode the '?' into a single path segment.
      this.router.navigateByUrl(tile.routingUrl);
    }
  }
}
